import React from "react";
import Header from "../components/Header";
import SEO from "../components/SEO";
import { Link } from "react-router-dom";

const icons = {
  check: (
    <svg
      className="w-4 h-4 text-current"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5 12l5 5L20 7"
      />
    </svg>
  ),
  mission: (
    <svg
      className="w-6 h-6 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <circle cx="12" cy="12" r="8" strokeWidth="1.8" />
      <circle cx="12" cy="12" r="2.5" strokeWidth="1.8" />
      <path strokeWidth="1.8" d="M12 4v2M12 18v2M4 12h2M18 12h2" />
    </svg>
  ),
  growth: (
    <svg
      className="w-6 h-6 text-[#2C3E50]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4 16l5-5 4 4 7-8"
      />
      <path
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M14 7h6v6"
      />
    </svg>
  ),
  team: (
    <svg
      className="w-6 h-6 text-[#2C3E50]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2M10 11a4 4 0 100-8 4 4 0 000 8ZM20 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"
      />
    </svg>
  ),
  location: (
    <svg
      className="w-4 h-4 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
      />
      <path
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
      />
    </svg>
  ),
  openings: (
    <svg
      className="w-4 h-4 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M17 20h5V4H2v16h5M7 20h10M9 4v4m6-4v4"
      />
    </svg>
  ),
  time: (
    <svg
      className="w-4 h-4 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <circle cx="12" cy="12" r="9" strokeWidth="2" />
      <path
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 7v5l3 2"
      />
    </svg>
  ),
  hiring: (
    <svg
      className="w-4 h-4 text-white"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 3v18M3 12h18"
      />
    </svg>
  ),
  training: (
    <svg
      className="w-6 h-6 text-[#2C3E50]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path strokeWidth="1.8" d="M4 7l8-4 8 4-8 4-8-4Z" />
      <path strokeWidth="1.8" d="M8 11v4c0 1.5 2 3 4 3s4-1.5 4-3v-4" />
    </svg>
  ),
  compensation: (
    <svg
      className="w-6 h-6 text-[#C5A047]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 1v22M17 5H9.5a3.5 3.5 0 000 7H14.5a3.5 3.5 0 010 7H6"
      />
    </svg>
  ),
  holiday: (
    <svg
      className="w-6 h-6 text-green-600"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path strokeWidth="1.8" d="M12 3v18M3 12h18M5 5l14 14M19 5L5 19" />
    </svg>
  ),
  security: (
    <svg
      className="w-6 h-6 text-[#2C3E50]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 3l7 4v5c0 5-3.5 8-7 9-3.5-1-7-4-7-9V7l7-4Z"
      />
    </svg>
  ),
  career: (
    <svg
      className="w-6 h-6 text-red-500"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4 16l5-5 4 4 7-8"
      />
      <path
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M14 7h6v6"
      />
    </svg>
  ),
  development: (
    <svg
      className="w-6 h-6 text-amber-500"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <circle cx="12" cy="12" r="4" strokeWidth="1.8" />
      <path
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 2v4M12 18v4M2 12h4M18 12h4M5 5l3 3M16 16l3 3M19 5l-3 3M8 16l-3 3"
      />
    </svg>
  ),
  email: (
    <svg
      className="w-5 h-5 mr-2"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
      />
    </svg>
  ),
  arrow: (
    <svg
      className="ml-3 w-5 h-5"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M14 5l7 7m0 0l-7 7m7-7H3"
      />
    </svg>
  ),
};

const benefits = [
  {
    icon: icons.training,
    title: "Comprehensive Training",
    desc: "On-the-job training and mentorship",
  },
  {
    icon: icons.compensation,
    title: "Competitive Compensation",
    desc: "Fixed salary + bonuses",
  },
  {
    icon: icons.holiday,
    title: "Holiday Premium",
    desc: "Holiday premium pay",
  },
  {
    icon: icons.security,
    title: "Social Security",
    desc: "CNSS registration",
  },
  {
    icon: icons.career,
    title: "Career Growth",
    desc: "Merit-based advancement opportunities",
  },
  {
    icon: icons.development,
    title: "Long-term Development",
    desc: "Career advancement opportunities",
  },
];

const Careers = () => {
  return (
    <>
      <SEO
        title="Careers | Providence Federal Group"
        description="Join our team at Providence Federal Group. Explore career opportunities in federal contracting and business development."
        keywords="careers, jobs, employment, federal contracting, business development, SDVOSB"
      />

      <div className="min-h-screen bg-white">
        <Header />

        {/* Hero Banner */}
        <section className="bg-gradient-to-r from-[#2C3E50] via-[#2C3E50] to-[#1A365D] text-white pt-40 pb-24">
          <div className="max-w-7xl mx-auto px-4 text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight mt-20" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              Join Our Mission
            </h1>
            <p className="text-xl md:text-2xl max-w-4xl mx-auto leading-relaxed">
              Build a meaningful career with a{" "}
              <span className="font-semibold text-[#C5A047]">
                Service-Disabled Veteran-Owned Business
              </span>{" "}
              dedicated to supporting federal missions and making a difference.
            </p>
          </div>
        </section>

        {/* Career Introduction */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                  Grow Your Career With Purpose
                </h2>
                <p className="text-lg text-gray-600 mb-6">
                  At Providence Federal Group, we believe in investing in talent
                  and providing opportunities for professional growth. As a
                  rapidly expanding SDVOSB, we offer unique career paths in
                  federal contracting, business development, and mission support
                  services.
                </p>
                <p className="text-lg text-gray-600 mb-8">
                  Our team combines veteran leadership with fresh perspectives to
                  deliver exceptional results for federal clients. We foster a
                  culture of excellence, integrity, and continuous learning.
                </p>

                <div className="flex flex-wrap gap-4">
                  <div className="bg-blue-50 px-4 py-2 rounded-lg inline-flex items-center gap-2">
                    <span className="text-blue-600">{icons.check}</span>
                    <span className="text-blue-600 font-semibold">
                      Professional Development
                    </span>
                  </div>

                  <div className="bg-amber-50 px-4 py-2 rounded-lg inline-flex items-center gap-2">
                    <span className="text-amber-600">{icons.check}</span>
                    <span className="text-amber-600 font-semibold">
                      Competitive Benefits
                    </span>
                  </div>

                  <div className="bg-emerald-50 px-4 py-2 rounded-lg inline-flex items-center gap-2">
                    <span className="text-emerald-600">{icons.check}</span>
                    <span className="text-emerald-600 font-semibold">
                      Growth Opportunities
                    </span>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl shadow-xl border border-gray-200">
                <h3 className="text-2xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                  Why Join PFG?
                </h3>

                <div className="space-y-6">
                  <div className="flex items-start">
                    <div className="flex-shrink-0 w-12 h-12 bg-[#C5A047]/10 rounded-lg flex items-center justify-center mr-4">
                      {icons.mission}
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-900 mb-2">
                        Mission-Focused Work
                      </h4>
                      <p className="text-gray-600">
                        Contribute to meaningful projects that support national
                        priorities and veteran care.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="flex-shrink-0 w-12 h-12 bg-[#2C3E50]/10 rounded-lg flex items-center justify-center mr-4">
                      {icons.growth}
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-900 mb-2">
                        Career Advancement
                      </h4>
                      <p className="text-gray-600">
                        Clear pathways for growth and professional development in
                        federal contracting.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start">
                    <div className="flex-shrink-0 w-12 h-12 bg-[#2C3E50]/10 rounded-lg flex items-center justify-center mr-4">
                      {icons.team}
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-900 mb-2">
                        Supportive Team
                      </h4>
                      <p className="text-gray-600">
                        Work alongside experienced professionals who mentor and
                        support your growth.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Current Openings */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                Current Open Positions
              </h2>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                Explore our current career opportunities. We&apos;re looking for
                talented individuals to join our growing team.
              </p>
            </div>

            {/* Job Opening Card */}
            <div className="max-w-4xl mx-auto">
              <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-200">
                {/* Job Header */}
                <div className="bg-gradient-to-r from-[#2C3E50] to-[#1A365D] p-8 text-white">
                  <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                    <div>
                      <div className="inline-flex items-center px-3 py-1 bg-[#C5A047] rounded-full text-sm font-semibold mb-3 gap-2">
                        {icons.hiring}
                        <span>WE ARE HIRING</span>
                      </div>

                      <h3 className="text-2xl md:text-3xl font-bold mb-2" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                        Associate, Business Development (Entry Level)
                      </h3>

                      <div className="flex flex-wrap gap-4 mt-4">
                        <div className="flex items-center gap-2">
                          {icons.location}
                          <span>Tetouan, Morocco (Onsite)</span>
                        </div>

                        <div className="flex items-center gap-2">
                          {icons.openings}
                          <span>2 Openings</span>
                        </div>

                        <div className="flex items-center gap-2">
                          {icons.time}
                          <span>Full Time</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Job Details */}
                <div className="p-8">
                  {/* About the Role */}
                  <div className="mb-10">
                    <h4 className="text-xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200">
                      About the Role
                    </h4>
                    <p className="text-gray-700 mb-4">
                      <span className="font-semibold text-[#2C3E50]">
                        Providence Federal Group (PFG)
                      </span>{" "}
                      is seeking two (2) full-time Associates, Business
                      Development (Entry Level) to support business development
                      activities related to U.S. federal contracting
                      opportunities. These roles are ideal for motivated,
                      detail-oriented individuals at the beginning of their
                      professional careers who are eager to learn and grow in the
                      field of business development and government contracting.
                    </p>
                    <p className="text-gray-700">
                      The Associates will work closely with senior leadership and
                      internal teams to support opportunity research, pipeline
                      tracking, and coordination of business development efforts.
                      No prior experience is required, as comprehensive training
                      will be provided.
                    </p>
                  </div>

                  {/* Key Responsibilities */}
                  <div className="mb-10">
                    <h4 className="text-xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200">
                      Key Responsibilities
                    </h4>
                    <p className="text-gray-700 mb-4">
                      Under guidance and structured training, the Associates,
                      Business Development will:
                    </p>
                    <ul className="space-y-3">
                      <li className="flex items-start">
                        <span className="text-[#C5A047] mr-3 mt-1">•</span>
                        <span className="text-gray-700">
                          Conduct online research to identify potential partners
                          and vendors
                        </span>
                      </li>
                      <li className="flex items-start">
                        <span className="text-[#C5A047] mr-3 mt-1">•</span>
                        <span className="text-gray-700">
                          Manage contact lists and data using Microsoft Excel
                        </span>
                      </li>
                      <li className="flex items-start">
                        <span className="text-[#C5A047] mr-3 mt-1">•</span>
                        <span className="text-gray-700">
                          Maintain accurate and well-organized documentation and
                          reports
                        </span>
                      </li>
                      <li className="flex items-start">
                        <span className="text-[#C5A047] mr-3 mt-1">•</span>
                        <span className="text-gray-700">
                          Support research and identification of U.S. federal
                          contracting opportunities
                        </span>
                      </li>
                    </ul>
                  </div>

                  {/* Work Arrangement */}
                  <div className="mb-10">
                    <h4 className="text-xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200">
                      Work Arrangement & Schedule
                    </h4>
                    <div className="bg-blue-50 p-6 rounded-lg border border-blue-100">
                      <p className="text-gray-700 mb-2">
                        These roles are <span className="font-semibold">office-based</span>, with onsite attendance required at the Providence Federal Group back office in Tetouan.
                      </p>
                      <p className="text-gray-700">
                        Standard working hours follow a <span className="font-semibold">U.S. business schedule</span>, from{" "}
                        <span className="font-semibold">
                          2:00 PM to 11:00 PM Morocco time
                        </span>
                        , consistent with a full-time workload and applicable
                        labor standards.
                      </p>
                    </div>
                  </div>

                  {/* Qualifications */}
                  <div className="mb-10">
                    <h4 className="text-xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200">
                      Qualifications
                    </h4>
                    <div className="bg-gray-50 p-5 rounded-lg mb-5">
                      <h5 className="font-semibold text-gray-900 mb-3 text-lg">
                        Education
                      </h5>
                      <p className="text-gray-700">
                        <span className="text-[#C5A047] mr-2 mt-1">•</span> Bachelor's degree required (Business, International Relations, Marketing, or a related field preferred)
                      </p>
                    </div>
                    <div className="bg-gray-50 p-5 rounded-lg">
                      <h5 className="font-semibold text-gray-900 mb-3 text-lg">
                        Requirements
                      </h5>
                      <ul className="space-y-2">
                        <li className="flex items-start">
                          <span className="text-[#C5A047] mr-2 mt-1">•</span>
                          <span className="text-gray-700">
                            No prior professional experience required
                          </span>
                        </li>
                        <li className="flex items-start">
                          <span className="text-[#C5A047] mr-2 mt-1">•</span>
                          <span className="text-gray-700">
                            Fluency in English (written and spoken) is required
                          </span>
                        </li>
                        <li className="flex items-start">
                          <span className="text-[#C5A047] mr-2 mt-1">•</span>
                          <span className="text-gray-700">
                            Strong organizational skills and attention to detail
                          </span>
                        </li>
                        <li className="flex items-start">
                          <span className="text-[#C5A047] mr-2 mt-1">•</span>
                          <span className="text-gray-700">
                            Willingness to learn and ability to work in a
                            structured, professional environment
                          </span>
                        </li>
                        <li className="flex items-start">
                          <span className="text-[#C5A047] mr-2 mt-1">•</span>
                          <span className="text-gray-700">
                            Basic computer proficiency (Microsoft Office &
                            Adobe or equivalent tools)
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>

                  {/* Benefits */}
                  <div className="mb-10">
                    <h4 className="text-xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200">
                      Benefits
                    </h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                      {benefits.map((benefit, index) => (
                        <div
                          key={index}
                          className="bg-gradient-to-br from-gray-50 to-white p-5 rounded-lg border border-gray-200"
                        >
                          <div className="mb-3">{benefit.icon}</div>
                          <h5 className="font-semibold text-gray-900 mb-2">
                            {benefit.title}
                          </h5>
                          <p className="text-sm text-gray-600">{benefit.desc}</p>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* How to Apply */}
                  <div className="bg-gradient-to-r from-emerald-50 to-green-50 p-8 rounded-xl border border-emerald-200">
                    <h4 className="text-xl font-bold text-gray-900 mb-4">
                      How to Apply
                    </h4>
                    <div className="space-y-4">
                      <p className="text-gray-700">
                        Interested candidates should send their resume and cover
                        letter to:
                      </p>
                      <div className="bg-white p-4 rounded-lg border border-gray-300">
                        <div className="flex items-center justify-between gap-4 flex-col sm:flex-row">
                          <div>
                            <p className="font-mono text-lg font-semibold text-gray-900 break-all">
                              support@providencefederal.com
                            </p>
                            <p className="text-gray-600 text-sm mt-1">
                              Please use the subject line:{" "}
                              <span className="font-semibold">
                                "BD Associate"
                              </span>
                            </p>
                          </div>
                          <a
                            href="mailto:support@providencefederal.com?subject=BD Associate"
                            className="bg-[#C5A047] text-white px-4 py-2 rounded-lg font-semibold whitespace-nowrap"
                          >
                            Apply Now
                          </a>
                        </div>
                      </div>
                      <p className="text-gray-600 text-sm">
                        We review applications on a rolling basis. Only
                        shortlisted candidates will be contacted for interviews.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Additional Career Info */}
            <div className="mt-16 text-center mb-20">
              <div className="inline-flex items-center justify-center mb-6">
                <div className="w-16 h-1 bg-[#C5A047]"></div>
                <span className="mx-6 text-gray-500 text-sm font-medium tracking-widest uppercase">
                  Future Opportunities
                </span>
                <div className="w-16 h-1 bg-[#C5A047]"></div>
              </div>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-8">
                Don&apos;t see a position that matches your skills? We&apos;re
                growing rapidly and new opportunities arise frequently. Send us
                your resume for future consideration.
              </p>
              <Link
                to="/contact"
                className="inline-flex items-center px-6 py-3 bg-gray-800 text-white rounded-lg font-medium hover:bg-gray-900 transition-colors"
              >
                Submit General Application
                {icons.arrow}
              </Link>
            </div>

            <div className="bg-gradient-to-r from-[#1E3A8A] to-[#2C3E50] rounded-2xl p-8 md:p-12 text-white text-center shadow-xl">
              <div className="max-w-3xl mx-auto">
                <div className="flex justify-center mb-6">
                  <div className="w-16 h-1 bg-[#C5A047]"></div>
                </div>

                <h3
                  className="font-display text-3xl md:text-4xl font-medium mb-6"
                  style={{ fontFamily: "'Cormorant Garamond', serif" }}
                >
                  Ready to Partner with Purpose?
                </h3>

                <p className="text-lg md:text-xl mb-8 text-white/90 leading-relaxed">
                  Let&apos;s discuss how our certified capabilities and mission-focused
                  approach can support your agency&apos;s objectives.
                </p>

                <div className="flex flex-col sm:flex-row justify-center gap-4">
                  <Link
                    to="/contact"
                    className="px-8 py-4 bg-[#C5A047] text-white font-semibold rounded-full hover:bg-[#D4AF37] transition-all shadow-lg inline-flex items-center justify-center"
                  >
                    <svg
                      className="w-5 h-5 mr-2"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                      />
                    </svg>
                    Request a Capabilities Brief
                  </Link>

                  <a
                    href="tel:14013469778"
                    className="px-8 py-4 bg-white/10 text-white font-semibold rounded-full hover:bg-white/20 transition-all border border-white/20 inline-flex items-center justify-center"
                  >
                    <svg
                      className="w-5 h-5 mr-2"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M3 5.5C3 4.12 4.12 3 5.5 3h2.2a2 2 0 011.94 1.515l.516 2.066a2 2 0 01-.45 1.948l-1.27 1.27a16 16 0 006.586 6.586l1.27-1.27a2 2 0 011.948-.45l2.066.516A2 2 0 0121 16.72V19a2 2 0 01-2 2h-1C10.716 21 3 13.284 3 6V5.5z"
                      />
                    </svg>
                    Call Us
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Careers;